import React, { useState } from 'react';
import { Button, Form, Modal, Popup } from 'semantic-ui-react';
import WarehousesDropdown from 'components/WarehousesDropdown/WarehousesDropdown';
import { isDSV, isSFP } from 'modules/user-has-permission/user-has-permission';
import MarketplacesDropdown from 'components/MarketplacesDropdown/MarketplacesDropdown';
import useEditUserReducer, {
  updateMarketplacesAction,
  updateWarehouseAction,
} from 'components/EditUserModal/useEditUserReducer';
import './edit-user-modal.scss';

export default function EditUserModal({
  initialData,
  warehouses,
  marketplaces,
  onUpdateUser = () => {},
}) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [state, dispatch] = useEditUserReducer({
    id: initialData.id,
    warehouse_id: initialData.warehouse?.id || null,
    marketplace_ids:
      initialData.marketplaces?.map((marketplace) => marketplace.id) || [],
  });

  return (
    <Modal
      className="edit-user-modal"
      open={modalIsOpen}
      onClose={() => setModalIsOpen(false)}
      trigger={
        <Popup
          className="base-tooltip"
          content="Editar configuración del usuario"
          trigger={
            <Button
              circular
              icon="edit outline"
              onClick={() => setModalIsOpen(true)}
            />
          }
        />
      }
    >
      <Modal.Header>Configuración del usuario</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Field role="region" aria-label="Warehouse">
            <label>Almacén</label>
            <WarehousesDropdown
              warehouses={warehouses}
              value={state.warehouse_id}
              onChange={(event, { value }) =>
                dispatch(updateWarehouseAction(value))
              }
            />
          </Form.Field>
          {(isDSV() || isSFP()) && (
            <Form.Field role="region" aria-label="Marketplace">
              <label>Marketplaces</label>
              <MarketplacesDropdown
                marketplaces={marketplaces}
                value={state.marketplace_ids}
                onChange={(event, { value }) =>
                  dispatch(updateMarketplacesAction(value))
                }
              />
            </Form.Field>
          )}
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setModalIsOpen(false)}>Cancelar</Button>
        <Button primary onClick={(event, data) => onUpdateUser(state)}>
          Actualizar usuario
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
